import script from "./QuickpaySettingsFaq.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuickpaySettingsFaq.vue?vue&type=script&setup=true&lang=ts"

import "./QuickpaySettingsFaq.vue?vue&type=style&index=0&id=0d399ab2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d399ab2"]])

export default __exports__